/**
 * Waitlist gate. By default `/login` and `/signup` show a waitlist
 * screen with a "Notify me" button that opens the user's mail client.
 * Append `?preview=<anything>` to either URL to bypass the waitlist
 * and render the real auth form. Once the gate is bypassed in a tab,
 * the choice is persisted in sessionStorage so subsequent navigation
 * (e.g. signin ↔ signup) doesn't re-trigger the waitlist.
 *
 * Persistence is intentionally session-scoped (not localStorage) so
 * closing the browser resets the gate — the waitlist stays the
 * default until the launch.
 */

const SESSION_KEY = "memkernel.preview";

/** Email shown on the waitlist button. Tweak when we go live. */
export const WAITLIST_EMAIL = "hello@memkernel.com";

export function isPreviewMode(): boolean {
  if (typeof window === "undefined") return false;
  const url = new URL(window.location.href);
  if (url.searchParams.has("preview")) {
    try {
      sessionStorage.setItem(SESSION_KEY, "1");
    } catch {
      /* ignore */
    }
    return true;
  }
  try {
    return sessionStorage.getItem(SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

export function waitlistMailtoUrl(): string {
  const subject = encodeURIComponent("MemKernel waitlist");
  const body = encodeURIComponent(
    "Hi MemKernel team,\n\nPlease add me to the waitlist.\n\nThanks!",
  );
  return `mailto:${WAITLIST_EMAIL}?subject=${subject}&body=${body}`;
}
